<div class="header">
  <div class="headerTitle">
    <h2 *ngIf="order" class="doc_title">Заказ № {{ order?.id }}</h2>
    <h2 *ngIf="!order" class="doc_title">Новый заказ</h2>
    <span>Товаров: {{ products.length }} · {{ supportService.formatMoney(getSum()) }}</span>
  </div>
  <div class="headerActions">
    <button *ngIf="order?.id" type="button" mat-stroked-button color="warn"
      (click)="openOrderRefusal()" [disabled]="saving || supplySaving">
      <mat-icon>currency_exchange</mat-icon> {{ order?.is_canceled ? 'Возврат денег' : 'Отказ и возврат' }}
    </button>
    <button type="button" mat-stroked-button #keyboardHelpTooltip="matTooltip"
      [matTooltip]="keyboardHelpText" matTooltipClass="orderEditorKeyboardTooltip" matTooltipPosition="below"
      aria-keyshortcuts="Alt+0" (click)="keyboardHelpTooltip.toggle()">
      <mat-icon>keyboard</mat-icon> Клавиши
    </button>
    <button #addProductButton type="button" mat-flat-button color="primary" (click)="openDialog()"
      [disabled]="saving || supplySaving" aria-keyshortcuts="F2" matTooltip="Найти и добавить товар · F2">
      <mat-icon>add</mat-icon>
      Добавить товар
    </button>
    <button
      type="button"
      mat-icon-button
      (click)="drawer.toggle()"
      matTooltip="Показать или скрыть данные заказа"
      aria-label="Показать или скрыть данные заказа"
    >
      <mat-icon>tune</mat-icon>
    </button>
  </div>
</div>

<form #orderEditor [formGroup]="createForm">
  <mat-drawer-container class="wrapper" autosize>
    <mat-drawer
      #drawer
      class="example-sidenav"
      mode="side"
      [opened]="deviceType === 'DESKTOP'"
      position="end"
    >
      <div class="topForm drop-padding">
        <div class="sidePanelHeader">
          <div class="sidePanelHeaderIcon">
            <mat-icon>description</mat-icon>
          </div>
          <div>
            <h3>Данные заказа</h3>
            <span>Клиент, срок и получение</span>
          </div>
        </div>

        <div class="sideFormBody">
          <section class="sideSection sideSection--client">
            <div class="sideSectionTitle">
              <span class="sideSectionTitleIcon"><mat-icon>person</mat-icon></span>
              <span>Клиент (необязательно)</span>
              <a
                *ngIf="client?.id"
                class="clientProfileLink"
                [routerLink]="['/client/profile', client.id]"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Открыть карточку клиента в новой вкладке"
                matTooltip="Открыть карточку клиента в новой вкладке"
              >
                Карточка клиента
                <mat-icon aria-hidden="true">open_in_new</mat-icon>
              </a>
            </div>
            <app-client-selector data-order-focus="client" [control]="clientFormControl" [allowClear]="true"
              matTooltip="Клиент · Alt+1"></app-client-selector>
            <mat-form-field class="clientCarField" appearance="outline">
              <mat-label>Автомобиль (необязательно)</mat-label>
              <input
                matInput
                type="text"
                placeholder="Название или часть VIN"
                autocomplete="off"
                data-order-focus="car" aria-keyshortcuts="Alt+2" matTooltip="Автомобиль · Alt+2"
                [formControl]="clientCarFormControl"
                [matAutocomplete]="clientCarAutocomplete"
              />
              <mat-icon matSuffix>search</mat-icon>
              <button *ngIf="clientCarFormControl.value" type="button" mat-icon-button matSuffix
                aria-label="Очистить автомобиль" (click)="clientCarFormControl.setValue(null)">
                <mat-icon>close</mat-icon>
              </button>
              <mat-autocomplete
                #clientCarAutocomplete="matAutocomplete"
                [displayWith]="displayClientCar"
              >
                <mat-option
                  *ngFor="let car of filteredClientCars; trackBy: trackByClientCar"
                  [value]="car"
                >
                  <div class="clientCarOption">
                    <span>{{ car.description || 'Без названия' }}</span>
                    <small *ngIf="car.vin">{{ car.vin }}</small>
                  </div>
                </mat-option>
                <mat-option *ngIf="client?.cars?.length && !filteredClientCars.length" disabled>
                  Ничего не найдено
                </mat-option>
                <mat-option
                  class="clientCarCreateOption"
                  [value]="clientCarFormControl.value"
                  (onSelectionChange)="createClientCarFromOption($event.isUserInput)"
                >
                  <mat-icon>add</mat-icon>
                  Создать автомобиль
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </section>

          <section class="sideSection sideSection--execution">
            <div class="sideSectionTitle">
              <span class="sideSectionTitleIcon"><mat-icon>event_available</mat-icon></span>
              <span>Выполнение</span>
            </div>
            <div
              class="orderExpectedAtSummary"
              [class.orderExpectedAtSummary--empty]="!calculatedOrderExpectedAt"
            >
              <mat-icon>schedule</mat-icon>
              <div>
                <span>Готовность заказа</span>
                <strong>{{ calculatedOrderExpectedAtLabel }}</strong>
                <small>{{ calculatedOrderExpectedAtCaption }}</small>
              </div>
            </div>
            <app-warehouse-selector data-order-focus="warehouse" [control]="warehouseControl"
              matTooltip="Склад · Alt+4"></app-warehouse-selector>
            <p class="supplyHint" role="status" *ngIf="warehouseChangePending">
              После сохранения склад выдачи изменится на «{{ warehouse?.description }}».
              Сначала проверим свободный остаток нового склада для перерезервирования;
              недостающее количество потребует перемещения.
              Уже отобранный или отправленный товар будет учтён отдельно.
            </p>
          </section>

          <section class="sideSection sideSection--delivery deliveryBlock">
            <div class="sideSectionTitle">
              <span class="sideSectionTitleIcon"><mat-icon>local_shipping</mat-icon></span>
              <span>Получение</span>
            </div>
            <mat-button-toggle-group
              class="deliveryToggle"
              data-order-focus="delivery" matTooltip="Способ получения · Alt+5"
              [formControl]="deliveryMethodControl"
              aria-label="Способ доставки"
            >
              <mat-button-toggle [value]="orderDeliveryMethod.PICKUP">Самовывоз</mat-button-toggle>
              <mat-button-toggle [value]="orderDeliveryMethod.NOVA_POSHTA">
                Нова пошта
              </mat-button-toggle>
            </mat-button-toggle-group>

            <div class="novaPoshtaPanel" *ngIf="isNovaPoshtaDelivery()">
              <ng-container *ngTemplateOutlet="novaPoshtaFields"></ng-container>
            </div>
          </section>

          <section class="sideSection sideSection--comment sideSection--last">
            <div class="sideSectionTitle">
              <span class="sideSectionTitleIcon"><mat-icon>notes</mat-icon></span>
              <span>Комментарий</span>
            </div>
            <mat-form-field appearance="outline">
              <textarea
                matInput
                aria-label="Комментарий"
                data-order-focus="comment" aria-keyshortcuts="Alt+6" matTooltip="Комментарий · Alt+6"
                [formControl]="descriptionFormControl"
                cdkAutosizeMinRows="1"
                cdkAutosizeMaxRows="5"
              ></textarea>
            </mat-form-field>
            <a
              class="sourceLink"
              *ngIf="partsSelectionLink as selectionLink"
              [routerLink]="['/parts-selection', selectionLink.id]"
            >
              <mat-icon>link</mat-icon>
              {{ selectionLink.label }}
            </a>
          </section>

          <details class="orderPlacesDetails" *ngIf="order">
            <summary>
              <mat-icon aria-hidden="true">inventory_2</mat-icon>
              <span>Где лежит заказ</span>
              <mat-icon class="orderPlacesChevron" aria-hidden="true">expand_more</mat-icon>
            </summary>
            <app-order-places [orderId]="order.id"></app-order-places>
          </details>
        </div>

        <div class="sideSave">
          <div class="sideSaveTotal">
            <span>Итого</span>
            <strong>{{ supportService.formatMoney(getSum()) }}</strong>
          </div>
          <div class="sideSaveActions">
            <button
              type="button"
              mat-flat-button
              color="primary"
              (click)="save(true)"
              [disabled]="saving || supplySaving || removeConfirmationPending || automaticSupplyPending || supplierPricingPending || (!!order && supplyLoading) || !hasPlannedSupply"
              matTooltip="Сохранить заказ и отметить черновики поставщикам как заказанные"
            >
              <mat-icon>local_shipping</mat-icon>
              Сохранить и заказать
            </button>
            <button
              type="button"
              mat-stroked-button
              color="primary"
              (click)="save()"
              aria-keyshortcuts="Control+s Control+Enter" matTooltip="Сохранить заказ · Ctrl+S или Ctrl+Enter"
              [disabled]="saving || supplySaving || removeConfirmationPending || automaticSupplyPending || supplierPricingPending || (!!order && supplyLoading)"
            >
              <mat-icon>save</mat-icon>
              Сохранить
            </button>
          </div>
        </div>
      </div>
    </mat-drawer>

    <div class="productsTable">
      <div>
        <div class="productRemovalNotice" *ngIf="removedProductsCount" role="status">
          <mat-icon aria-hidden="true">info_outline</mat-icon>
          <span>Удалено позиций: {{ removedProductsCount }}. Изменения ещё не сохранены.
            Связанные неполученные закупки отменятся и резерв снимется только при сохранении заказа.
            Без сохранения закупки и резервы не изменятся. Размещённый товар сразу станет свободным в текущей ячейке;
            товар в руках сотрудника станет доступен после размещения.</span>
        </div>
        <table #table mat-table [dataSource]="dataSource" formArrayName="products"
          cdkDropList [cdkDropListData]="products"
          [cdkDropListDisabled]="saving || supplySaving || products.length < 2"
          (cdkDropListDropped)="dropProductRow($event)">
          <ng-container matColumnDef="position">
            <th mat-header-cell *matHeaderCellDef>No.</th>
            <td mat-cell *matCellDef="let prod; let i = index">
              <div class="productPositionControl"
                cdkDrag cdkDragHandle cdkDragRootElement=".mat-row"
                cdkDragLockAxis="y" [cdkDragData]="prod"
                [cdkDragDisabled]="saving || supplySaving || products.length < 2"
                (cdkDragStarted)="hideProductImagePreview()">
                <button type="button" class="productDragHandle"
                  [disabled]="saving || supplySaving || products.length < 2"
                  [attr.aria-label]="'Переместить строку: ' + prod.value.product.description + ' ' + prod.value.product.article"
                  matTooltip="Перетащить строку">
                  <mat-icon aria-hidden="true">drag_indicator</mat-icon>
                </button>
                <span class="productPosition">{{ i + 1 }}</span>
                <div *cdkDragPreview class="orderProductDragPreview">
                  <img *ngIf="getProductImageUrl(prod.value.product) as imageUrl" [src]="imageUrl" alt="" />
                  <div>
                    <div class="productName">{{ prod.value.product.description }}</div>
                    <div class="productMeta">
                      <span class="productBrandLogoSlot" aria-hidden="true">
                        <img *ngIf="getProductBrandLogoUrl(prod.value.product) as logoUrl" class="productBrandLogo" [src]="logoUrl" alt="" />
                      </span>
                      <span class="productBrand">{{ prod.value.product.brand?.description }}</span>
                      <span class="productArticle">{{ prod.value.product.article }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </td>
          </ng-container>
          <ng-container matColumnDef="description">
            <th mat-header-cell *matHeaderCellDef>Товар</th>
            <td mat-cell *matCellDef="let prod">
              <div class="productDescriptionCell">
                <div class="productDescriptionMain">
                  <button
                    *ngIf="getProductImageUrl(prod.value.product) as imageUrl"
                    type="button"
                    class="productThumbnail"
                    aria-label="Увеличить изображение товара"
                    (mouseenter)="
                      showProductImagePreview($event, imageUrl, prod.value.product.description)
                    "
                    (mousemove)="moveProductImagePreview($event)"
                    (mouseleave)="hideProductImagePreview()"
                  >
                    <img
                      [src]="imageUrl"
                      [alt]="prod.value.product.description"
                      (error)="onProductImageError(imageUrl)"
                    />
                  </button>
                  <div *ngIf="!getProductImageUrl(prod.value.product)" class="productThumbnailPlaceholder" aria-hidden="true">
                    <mat-icon>image_not_supported</mat-icon>
                  </div>
                  <div class="productIdentity">
                    <div class="productName">{{ prod.value.product.description }}</div>
                    <div class="productMeta">
                      <span class="productBrandLogoSlot" aria-hidden="true">
                        <img
                          *ngIf="getProductBrandLogoUrl(prod.value.product) as logoUrl"
                          class="productBrandLogo"
                          [src]="logoUrl"
                          alt=""
                          (error)="onProductBrandLogoError(logoUrl)"
                        />
                      </span>
                      <span class="productBrand">{{ prod.value.product.brand?.description }}</span>
                      <button type="button" class="productArticle" *ngIf="prod.value.product.article"
                        [cdkCopyToClipboard]="prod.value.product.article"
                        (cdkCopyToClipboardCopied)="onProductArticleCopied($event, prod.value.product.article)"
                        [attr.aria-label]="'Скопировать артикул ' + prod.value.product.article"
                        matTooltip="Скопировать артикул">
                        {{ prod.value.product.article }}
                      </button>
                    </div>
                  </div>
                </div>
                <div class="productReturnMeta" *ngIf="prod.value.returned_quan > 0">
                  <span class="returnBadge">
                    Возврат {{ formatQuantity(prod.value.returned_quan) }}
                  </span>
                  <span class="returnDocs" *ngIf="prod.value.return_doc_ids?.length">
                    Док.: {{ getReturnDocIdsLabel(prod.value.return_doc_ids) }}
                  </span>
                </div>
              </div>
            </td>
          </ng-container>
          <ng-container matColumnDef="barcode">
            <th mat-header-cell *matHeaderCellDef>Штрихкод</th>
            <td mat-cell *matCellDef="let prod">
              {{ prod.value.product.barcode }}
            </td>
          </ng-container>
          <ng-container matColumnDef="provider">
            <th mat-header-cell *matHeaderCellDef>
              <div class="supplyColumnHeader">
                <span>Обеспечение</span>
                <button type="button" mat-button color="primary"
                  [disabled]="!products.length"
                  [attr.aria-label]="hasExpandedSupply ? 'Свернуть обеспечение всех товаров' : 'Развернуть обеспечение всех товаров'"
                  (click)="toggleAllSupplyExpanded()">
                  {{ hasExpandedSupply ? 'Свернуть все' : 'Развернуть все' }}
                </button>
              </div>
            </th>
            <td
              mat-cell
              *matCellDef="let prod; let supplyIndex = index"
              class="supplyCell"
              [attr.data-supply-product-id]="prod.value.product.id"
            >
              <ng-container *ngIf="getEditableSupplyLine(prod) as line">
                <ng-container *ngIf="getSupplyCoverage(prod, line) as coverage">
                  <div
                    class="supplyEditor"
                    [class.supplyEditor--complete]="coverage.status === 'complete'"
                    [class.supplyEditor--invalid]="coverage.status !== 'complete' && !canPreserveUnreconciledSupply(prod)"
                    [class.supplyEditor--reconciliation]="canPreserveUnreconciledSupply(prod)"
                  >
                    <div class="supplyCoverage" [class.supplyCoverage--over]="coverage.status === 'over' && !canPreserveUnreconciledSupply(prod)">
                      <div class="supplyCoverageText">
                        <strong *ngIf="!canPreserveUnreconciledSupply(prod)">{{ coverage.covered | number: '1.0-2' }} из {{ coverage.required | number: '1.0-2' }} шт.</strong>
                        <strong *ngIf="canPreserveUnreconciledSupply(prod)">В резерве {{ line.reserved | number: '1.0-2' }} из {{ coverage.required - (line.fulfilled || 0) | number: '1.0-2' }} шт.</strong>
                        <small *ngIf="canPreserveUnreconciledSupply(prod) && (line.fulfilled || 0) > 0">Отгружено {{ line.fulfilled | number: '1.0-2' }} шт.</small>
                        <small *ngIf="isAutomaticSupplyPending(prod)" role="status">Подбираем обеспечение…</small>
                        <small *ngIf="coverage.status === 'under' && !isAutomaticSupplyPending(prod)">Не распределено {{ coverage.remaining | number: '1.0-2' }}</small>
                        <small *ngIf="coverage.status === 'over' && !canPreserveUnreconciledSupply(prod)">Лишних {{ coverage.difference | number: '1.0-2' }}</small>
                        <small *ngIf="canPreserveUnreconciledSupply(prod)" role="status">Источник принятого товара ещё не подтверждён: {{ line.unattributed_reserved_quantity | number: '1.0-2' }} шт. Закупка требует сверки; остальные изменения можно сохранить.</small>
                      </div>
                      <div class="supplyHeaderActions">
                        <div class="supplyActions" [hidden]="!isSupplyExpanded(prod)">
                          <button
                            type="button"
                            mat-button
                            color="primary"
                            [matMenuTriggerFor]="sourceMenu"
                            aria-label="Добавить источник обеспечения"
                            matTooltip="Добавить источник обеспечения"
                            [disabled]="saving || supplySaving"
                          >
                            <mat-icon>add</mat-icon> Источник
                          </button>
                          <mat-menu #sourceMenu="matMenu">
                            <button type="button" mat-menu-item (click)="toggleWarehousePicker(prod)">
                              <mat-icon>warehouse</mat-icon>Свой склад
                            </button>
                            <button
                              type="button"
                              mat-menu-item
                              [disabled]="!canAddSupplyAllocation(prod, line)"
                              (click)="addSupplyAllocation(prod)"
                            >
                              <mat-icon>local_shipping</mat-icon>Поставщик
                            </button>
                          </mat-menu>
                          <button
                            type="button"
                            mat-icon-button
                            aria-label="Обновить остатки"
                            matTooltip="Обновить остатки"
                            [disabled]="saving || warehouseOptionsLoading"
                            (click)="refreshWarehouseOptions(true)"
                          >
                            <mat-icon>refresh</mat-icon>
                          </button>
                        </div>
                        <button type="button" mat-button color="primary" class="supplyDisclosure"
                          [attr.aria-expanded]="isSupplyExpanded(prod)"
                          [attr.aria-controls]="'order-supply-' + supplyIndex"
                          [attr.aria-label]="(isSupplyExpanded(prod) ? 'Свернуть обеспечение: ' : 'Развернуть обеспечение: ') + prod.value.product.description"
                          (click)="toggleSupplyExpanded(prod)">
                          {{ isSupplyExpanded(prod) ? 'Свернуть' : 'Развернуть' }}
                          <mat-icon aria-hidden="true">{{ isSupplyExpanded(prod) ? 'expand_less' : 'expand_more' }}</mat-icon>
                        </button>
                      </div>
                    </div>
                    <div class="supplyStockRelease" *ngIf="getPendingStockRelease(prod) as release">
                      <div>
                        <strong>{{ release.warehouse_name }} · снять резерв {{ release.quantity | number: '1.0-2' }} шт.</strong>
                        <small>При сохранении{{ release.picked > 0 ? ' · размещённый товар сразу станет свободным в текущей ячейке' : '' }}</small>
                      </div>
                      <button type="button" mat-button [disabled]="saving || supplySaving"
                        (click)="undoStockReservationRelease(prod)">Отменить отказ</button>
                    </div>
                    <div class="supplyCollapsedSources" *ngIf="!isSupplyExpanded(prod)">
                      <ng-container *ngIf="getSupplySourceSummaries(prod, line) as sources">
                        <div *ngFor="let source of sources; trackBy: trackSupplySourceSummary" class="supplySourceSummary"
                          [class.supplySourceSummary--warehouse]="source.kind === 'warehouse' || source.kind === 'shipped'"
                          [class.supplySourceSummary--transfer]="source.kind === 'transfer'"
                          [matTooltip]="source.label + ' · ' + source.quantity + ' · ' + source.status + (source.deliveryDetails ? ' · ' + source.deliveryDetails : '') + (source.details ? ' · ' + source.details : '')">
                          <mat-icon aria-hidden="true">{{ source.icon }}</mat-icon>
                          <strong>{{ source.label }}</strong>
                          <span>{{ source.quantity }}</span>
                          <small>{{ source.status }}</small>
                          <span *ngIf="source.deliveryLabel" class="supplySourceDelivery"
                            [class.supplySourceDelivery--estimated]="source.deliveryEstimated"
                            [attr.aria-label]="source.deliveryDetails">
                            {{ source.deliveryEstimated && source.deliveryLabel !== 'Срок?' ? '≈ ' : '' }}{{ source.deliveryLabel }}
                          </span>
                        </div>
                        <small class="supplyHint" *ngIf="!sources.length">Источники не выбраны</small>
                      </ng-container>
                    </div>
                    <div class="supplyEditorBody" [id]="'order-supply-' + supplyIndex" [hidden]="!isSupplyExpanded(prod)">
                      <div
                        class="supplyCommittedList"
                        *ngIf="
                          getCommittedSupplyAllocations(prod).length ||
                          hasTransferSupply(prod) ||
                          line.reserved > 0 ||
                          (line.fulfilled || 0) > 0
                        "
                      >
                        <div
                          class="supplyCommittedAllocation supplyCommittedAllocation--received supplyCommittedAllocation--stock"
                          *ngIf="line.reserved > 0"
                        >
                          <mat-icon>lock</mat-icon>
                          <strong>{{
                            line.warehouse_name || warehouse?.description || 'Склад заказа'
                          }}</strong>
                          <span>Резерв {{ line.reserved | number: '1.0-2' }} шт.</span>
                          <button type="button" mat-button color="warn" class="supplyStockReleaseButton"
                            [disabled]="saving || supplySaving || supplyLoading"
                            [attr.aria-label]="'Снять резерв: ' + (line.warehouse_name || warehouse?.description || 'Склад заказа')"
                            matTooltip="Отказаться от складского резерва при сохранении заказа"
                            (click)="declineStockReservation(prod)">Снять резерв</button>
                          <small *ngIf="(line.picked || 0) > 0"
                            >Из них отобрано {{ line.picked | number: '1.0-2' }}</small
                          >
                        </div>
                        <div
                          class="supplyCommittedAllocation supplyCommittedAllocation--received"
                          *ngIf="(line.fulfilled || 0) > 0"
                        >
                          <mat-icon>done_all</mat-icon>
                          <strong>Отгружено</strong>
                          <span>{{ line.fulfilled | number: '1.0-2' }} шт.</span>
                        </div>
                        <div
                          class="supplyCommittedAllocation supplyCommittedAllocation--transfer supplyCommittedAllocation--pending"
                          *ngIf="hasTransferSupply(prod) && !getTransferSources(prod).length"
                          [class.supplyCommittedAllocation--cancellable]="canCancelUndocumentedTransfer(prod)"
                        >
                          <mat-icon>swap_horiz</mat-icon>
                          <strong>{{ getTransferSupplyStatus(prod) }}</strong>
                          <span>{{ getTransferSupplyQuantity(prod) }} шт.</span>
                          <small *ngIf="getTransferDocIds(prod)">
                            Перемещение №{{ getTransferDocIds(prod) }}
                          </small>
                          <div class="supplyCommittedCancelActions" *ngIf="canCancelUndocumentedTransfer(prod)">
                            <button type="button" mat-button color="warn" [disabled]="saving || supplySaving || supplyLoading"
                              [attr.aria-label]="'Отменить перемещение: ' + prod.value.product?.description"
                              (click)="cancelTransferSource(prod)">Отменить</button>
                          </div>
                        </div>
                        <div
                          class="supplyCommittedAllocation supplyCommittedAllocation--transfer"
                          *ngFor="let source of getTransferSources(prod)"
                          [class.supplyCommittedAllocation--cancellable]="canCancelTransferSource(source)"
                        >
                          <mat-icon>swap_horiz</mat-icon>
                          <strong
                            >{{ source.source_warehouse }} → {{ source.target_warehouse }}</strong
                          >
                          <span>{{ source.quantity | number: '1.0-2' }} шт.</span>
                          <small
                            >{{ getTransferSourceStatus(source.status)
                            }}<ng-container *ngIf="source.received_quantity > 0">
                              · принято
                              {{ source.received_quantity | number: '1.0-2' }}</ng-container
                            ></small
                          >
                          <div class="supplyCommittedCancelActions" *ngIf="canCancelTransferSource(source)">
                            <button type="button" mat-button color="warn" [disabled]="saving || supplySaving || supplyLoading"
                              [attr.aria-label]="'Отменить перемещение №' + source.moving_doc_id"
                              (click)="cancelTransferSource(prod, source)">Отменить</button>
                          </div>
                          <a [routerLink]="['/docs/moving/update', source.moving_doc_id]"
                            >Перемещение №{{ source.moving_doc_id }}</a
                          >
                        </div>
                        <div
                          class="supplyCommittedAllocation supplyCommittedAllocation--transfer supplyCommittedAllocation--pending"
                          *ngIf="getTransferWithoutDocumentQuantity(prod) > 0"
                          [class.supplyCommittedAllocation--cancellable]="canCancelUndocumentedTransfer(prod)"
                        >
                          <mat-icon>swap_horiz</mat-icon>
                          <strong>Ожидает организации перемещения</strong>
                          <span
                            >{{
                              getTransferWithoutDocumentQuantity(prod) | number: '1.0-2'
                            }}
                            шт.</span
                          >
                          <small>Документ ещё не создан</small>
                          <div class="supplyCommittedCancelActions" *ngIf="canCancelUndocumentedTransfer(prod)">
                            <button type="button" mat-button color="warn" [disabled]="saving || supplySaving || supplyLoading"
                              [attr.aria-label]="'Отменить перемещение без документа: ' + prod.value.product?.description"
                              (click)="cancelTransferSource(prod)">Отменить</button>
                          </div>
                        </div>
                        <div
                          class="supplyCommittedAllocation"
                          *ngFor="let allocation of getCommittedSupplyAllocations(prod)"
                          [class.supplyCommittedAllocation--received]="
                            isCommittedSupplyReceived(allocation)
                          "
                          [class.supplyCommittedAllocation--cancellable]="canCancelSupplierAllocation(allocation)"
                        >
                          <mat-icon>lock</mat-icon>
                          <strong>{{ allocation.provider }}</strong>
                          <span>{{ getCommittedSupplyQuantity(allocation) }}</span>
                          <small>
                            {{ getCommittedSupplyStatus(allocation) }}
                            <ng-container *ngIf="allocation.contract_number">
                              · договор №{{ allocation.contract_number }}
                            </ng-container>
                            <ng-container *ngIf="allocation.expected_at && !isCommittedSupplyReceived(allocation)">
                              · до {{ allocation.expected_at | date: 'dd.MM.yyyy HH:mm' }}
                            </ng-container>
                          </small>
                          <div class="supplyCommittedCancelActions" *ngIf="canCancelSupplierAllocation(allocation)">
                            <button mat-button color="warn" type="button"
                              *ngFor="let buyId of allocation.buy_ids"
                              [disabled]="saving || supplySaving || supplyLoading"
                              [attr.aria-label]="'Отменить поставку от ' + allocation.provider + ', заказ поставщику №' + buyId"
                              matTooltip="Отменить неполученный остаток с указанием причины"
                              (click)="cancelSupplierAllocation(prod, allocation, buyId)">
                              Отменить<ng-container *ngIf="allocation.buy_ids.length > 1"> №{{ buyId }}</ng-container>
                            </button>
                          </div>
                        </div>
                      </div>

                      <div class="warehouseAllocationList">
                        <div
                          class="warehouseAllocation"
                          *ngFor="
                            let allocation of getWarehouseAllocations(prod).controls;
                            let allocationIndex = index
                          "
                          [formGroup]="getSupplyAllocationGroup(allocation)"
                          [attr.data-supply-warehouse-id]="allocation.value.warehouse_id"
                          [class.warehouseAllocation--conflict]="
                            isWarehouseConflict(prod, allocation)
                          "
                        >
                          <mat-icon>{{
                            allocation.value.warehouse_id === warehouse?.id ? 'store' : 'swap_horiz'
                          }}</mat-icon>
                          <div class="warehouseSourceIdentity">
                            <strong>{{ allocation.value.warehouse_name }}</strong>
                            <small>{{
                              allocation.value.warehouse_id === warehouse?.id
                                ? 'Резерв после сохранения'
                                : 'Перемещение после сохранения · срок уточняется'
                            }}</small>
                            <small *ngIf="getWarehouseOption(prod, allocation) as stock"
                              >Доступно {{ stock.available | number: '1.0-2' }} шт.</small
                            >
                          </div>
                          <mat-form-field appearance="standard">
                            <mat-label>Шт.</mat-label>
                            <input
                              matInput
                              type="number"
                              min="0.01"
                              step="0.01"
                              formControlName="quantity"
                              [readonly]="saving"
                            />
                            <mat-error>Больше нуля</mat-error>
                          </mat-form-field>
                          <button
                            type="button"
                            mat-icon-button
                            color="warn"
                            aria-label="Удалить склад"
                            [disabled]="saving"
                            (click)="removeWarehouseAllocation(prod, allocationIndex)"
                          >
                            <mat-icon>close</mat-icon>
                          </button>
                        </div>
                      </div>
                      <div class="supplyAllocationList">
                        <div
                          class="supplyAllocation"
                          *ngFor="
                            let allocation of getSupplyAllocations(prod).controls;
                            let allocationIndex = index
                          "
                          [formGroup]="getSupplyAllocationGroup(allocation)"
                        >
                          <app-provider-selector
                            [control]="getSupplyProviderControl(allocation)"
                            appearance="standard"
                            [suggestions]="getSupplyProviderOptions(prod)"
                            [suggestionsLoading]="isSupplyProviderOptionsLoading(prod)"
                            [panelWidth]="360"
                            (focusin)="loadSupplyProviderOptions(prod)"
                          ></app-provider-selector>
                          <mat-form-field appearance="standard" class="supplyQuantity">
                            <mat-label>Шт.</mat-label>
                            <input
                              matInput
                              type="number"
                              min="0.01"
                              step="0.01"
                              formControlName="quantity"
                            />
                          </mat-form-field>
                          <mat-form-field appearance="standard" class="supplyPurchasePrice">
                            <mat-label>Закупка, ₴</mat-label>
                            <input
                              matInput
                              type="number"
                              min="0.01"
                              step="0.01"
                              formControlName="purchasePrice"
                            />
                            <mat-error>Укажите цену больше нуля</mat-error>
                          </mat-form-field>
                          <app-contract-with-provider-selector
                            class="supplyContract"
                            [control]="getSupplyContractControl(allocation)"
                            [providerControl]="getSupplyProviderControl(allocation)"
                            [orgControl]="supplyOrgControl"
                            [filterByOrg]="false"
                            [autoSelect]="true"
                            appearance="standard"
                            label="Договор"
                          ></app-contract-with-provider-selector>
                          <mat-form-field appearance="standard" class="supplyExpectedAt">
                            <mat-label>Поставка</mat-label>
                            <input
                              matInput
                              formControlName="expectedAt"
                              [matDatepicker]="supplyExpectedAtPicker"
                            />
                            <mat-datepicker-toggle
                              matSuffix
                              [for]="supplyExpectedAtPicker"
                            ></mat-datepicker-toggle>
                            <mat-datepicker #supplyExpectedAtPicker></mat-datepicker>
                          </mat-form-field>
                          <mat-form-field appearance="standard" class="supplyExpectedTime">
                            <mat-label>Время</mat-label>
                            <input
                              matInput
                              type="text"
                              inputmode="numeric"
                              autocomplete="off"
                              mask="Hh:m0"
                              [dropSpecialCharacters]="false"
                              [leadZeroDateTime]="true"
                              placeholder="00:00"
                              formControlName="expectedTime"
                            />
                          </mat-form-field>
                          <button
                            type="button"
                            mat-icon-button
                            color="warn"
                            aria-label="Удалить поставщика"
                            matTooltip="Удалить поставщика"
                            (click)="removeSupplyAllocation(prod, allocationIndex)"
                          >
                            <mat-icon>close</mat-icon>
                          </button>
                        </div>
                      </div>


                      <div class="warehousePicker" *ngIf="warehousePickerRow === prod">
                        <div class="warehousePickerHeader">
                          <strong>Наши склады</strong
                          ><button
                            type="button"
                            mat-icon-button
                            aria-label="Закрыть склады"
                            (click)="warehousePickerRow = null"
                          >
                            <mat-icon>close</mat-icon>
                          </button>
                        </div>
                        <small *ngIf="coverage.remaining <= 0"
                          >Чтобы сменить источник, уменьшите или удалите выбранное
                          количество.</small
                        >
                        <small *ngIf="warehouseOptionsLoading">Обновляем остатки…</small>
                        <button
                          class="warehouseOption"
                          type="button"
                          *ngFor="let stock of getWarehouseOptions(prod)"
                          (click)="addWarehouseAllocation(prod, stock)"
                          [disabled]="
                            saving ||
                            warehouseOptionsLoading ||
                            !!warehouseOptionsError ||
                            getWarehouseRemaining(stock) <= 0 ||
                            coverage.remaining <= 0
                          "
                        >
                          <strong
                            >{{ stock.warehouse_name
                            }}<span *ngIf="stock.is_target"> · склад заказа</span></strong
                          >
                          <span
                            >Доступно {{ stock.available | number: '1.0-2' }} · На складе
                            {{ stock.on_hand | number: '1.0-2' }} · В резерве
                            {{ stock.reserved | number: '1.0-2' }}</span
                          >
                          <small *ngIf="getWarehouseRemaining(stock) !== stock.available"
                            >Свободно с учётом выбора:
                            {{ getWarehouseRemaining(stock) | number: '1.0-2' }}</small
                          >
                          <small *ngIf="!stock.is_target">Перемещение · срок уточняется</small>
                        </button>
                        <small
                          *ngIf="
                            !warehouseOptionsLoading &&
                            !getWarehouseOptions(prod).length &&
                            !warehouseOptionsError
                          "
                          >Нет данных об остатках</small
                        >
                      </div>
                      <small class="warehouseStockError" *ngIf="warehouseOptionsError">{{
                        warehouseOptionsError
                      }}</small>
                      <small
                        class="warehouseCheckedAt"
                        *ngIf="
                          warehouseCheckedAt &&
                          (warehousePickerRow === prod || getWarehouseAllocations(prod).length)
                        "
                        >Остатки на {{ warehouseCheckedAt | date: 'HH:mm:ss' }}. Резервируем при
                        сохранении.</small
                      >
                    </div>
                  </div>
                </ng-container>
              </ng-container>
            </td>
          </ng-container>
          <ng-container matColumnDef="price">
            <th mat-header-cell *matHeaderCellDef>Цена</th>
            <td mat-cell *matCellDef="let prod; let index = index" [formGroupName]="index">
              <mat-form-field appearance="standard">
                <input
                  matInput
                  aria-label="Цена"
                  type="number"
                  [attr.data-order-row]="index" data-order-field="price"
                  (focus)="activeProductIndex = index"
                  matTooltip="Enter → количество · ↑/↓ → другой товар"
                  (input)="changeRow(prod, 'price')"
                  formControlName="price"
                />
                <mat-hint *ngIf="isSupplierPricePending(prod)" role="status">Пересчёт цены…</mat-hint>
              </mat-form-field>
              <button *ngIf="hasSupplierPriceError(prod)" type="button" mat-button color="warn"
                matTooltip="Не удалось рассчитать цену по таблице наценки"
                aria-label="Повторить расчёт розничной цены" (click)="refreshSupplierRetailPrice(prod, true)">
                Повторить расчёт
              </button>
            </td>
          </ng-container>
          <ng-container matColumnDef="sum">
            <th mat-header-cell *matHeaderCellDef>Сумма</th>
            <td mat-cell *matCellDef="let prod; let index = index" [formGroupName]="index">
              <mat-form-field appearance="standard">
                <input
                  matInput
                  aria-label="Сумма"
                  type="number"
                  (input)="changeRow(prod, 'sum')"
                  [attr.data-order-row]="index" data-order-field="sum"
                  (focus)="activeProductIndex = index"
                  formControlName="sum"
                />
              </mat-form-field>
            </td>
          </ng-container>
          <ng-container matColumnDef="quan">
            <th mat-header-cell *matHeaderCellDef>Кол-во</th>
            <td mat-cell *matCellDef="let prod; let index = index" [formGroupName]="index">
              <mat-form-field appearance="standard">
                <input
                  matInput
                  aria-label="Количество"
                  type="number"
                  (input)="changeRow(prod, 'quan')"
                  [attr.data-order-row]="index" data-order-field="quan"
                  (focus)="activeProductIndex = index"
                  matTooltip="Enter → следующий товар · Shift+Enter → цена · ↑/↓ → другой товар"
                  formControlName="quan"
                />
              </mat-form-field>
            </td>
          </ng-container>
          <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef aria-label="Действия"></th>
            <td mat-cell *matCellDef="let prod; let index = index">
              <button
                mat-icon-button
                color="warn"
                type="button"
                [disabled]="saving || supplySaving || supplyLoading || removeConfirmationPending"
                [attr.aria-label]="'Удалить товар ' + prod.value.product.description"
                (click)="removeProduct(prod)"
              >
                <mat-icon>remove</mat-icon>
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; let index = index; columns: displayedColumns"
            [class.keyboardProductRow]="activeProductIndex === index" (focusin)="activeProductIndex = index">
          </tr>
        </table>
        <div class="productsEmptyState" *ngIf="!products.length">
          <div class="productsEmptyStateIcon">
            <mat-icon>inventory_2</mat-icon>
          </div>
          <strong>Добавьте товары в заказ</strong>
          <span>Здесь появятся цена, количество и источники товара по каждой позиции.</span>
          <button type="button" mat-stroked-button color="primary" (click)="openDialog()">
            <mat-icon>add</mat-icon>
            Добавить товар
          </button>
        </div>
      </div>
    </div>
  </mat-drawer-container>
</form>

<ng-template #removeProductsDialog let-data>
  <h2 mat-dialog-title>{{ data.count === 1 ? 'Удалить товар из заказа?' : 'Удалить товары из заказа?' }}</h2>
  <mat-dialog-content>
    <p *ngIf="data.product"><strong>{{ data.product }}</strong></p>
    <p *ngIf="data.count > 1">Позиций к удалению: {{ data.count }}.</p>
    <p>При сохранении заказа товары будут удалены, связанные неполученные закупки отменены,
      а их складской резерв снят.
      Размещённый товар сразу станет свободным в текущей ячейке.
      Товар в руках сотрудника станет доступен после размещения.</p>
    <p>До сохранения заказа закупки и резервы не изменятся.
      Незавершённые перемещения нужно отменить отдельно. Приёмку без сверки сначала нужно сверить.
      Отгруженные товары удалить нельзя.</p>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button type="button" mat-button [mat-dialog-close]="false" cdkFocusInitial>Оставить</button>
    <button type="button" mat-flat-button color="warn" [mat-dialog-close]="true">Удалить при сохранении</button>
  </mat-dialog-actions>
</ng-template>

<ng-template #novaPoshtaFields>
  <div class="novaPoshtaFields">
    <mat-form-field appearance="outline">
      <mat-label>Город Новой почты</mat-label>
      <input
        matInput
        [formControl]="novaPoshtaCityControl"
        [matAutocomplete]="novaPoshtaCityAutocomplete"
      />
      <mat-autocomplete
        #novaPoshtaCityAutocomplete="matAutocomplete"
        [displayWith]="displayNovaPoshtaCity"
        (optionSelected)="onNovaPoshtaCitySelected()"
      >
        <mat-option *ngFor="let city of filteredNovaPoshtaCities$ | async" [value]="city">
          <span>{{ city.present }}</span>
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Отделение или почтомат</mat-label>
      <input
        #novaPoshtaWarehouseInput
        #novaPoshtaWarehouseTrigger="matAutocompleteTrigger"
        matInput
        [formControl]="novaPoshtaWarehouseControl"
        [matAutocomplete]="novaPoshtaWarehouseAutocomplete"
        [disabled]="!selectedNovaPoshtaCity"
        (focus)="onNovaPoshtaWarehouseInputActive()"
        (input)="onNovaPoshtaWarehouseInputActive()"
        (keydown)="onNovaPoshtaWarehouseKeydown($event)"
        (blur)="onNovaPoshtaWarehouseInputBlur()"
      />
      <mat-autocomplete
        #novaPoshtaWarehouseAutocomplete="matAutocomplete"
        [displayWith]="displayNovaPoshtaWarehouse"
      >
        <mat-option
          *ngFor="let warehouse of filteredNovaPoshtaWarehouses$ | async"
          [value]="warehouse"
        >
          <span>{{ getNovaPoshtaWarehouseKindLabel(warehouse) }}</span>
          <small class="novaPoshtaOptionAddress">
            {{ warehouse.shortAddress || warehouse.description }}
          </small>
        </mat-option>
      </mat-autocomplete>
      <mat-hint *ngIf="!selectedNovaPoshtaCity">Сначала выберите город</mat-hint>
    </mat-form-field>

    <div
      class="novaPoshtaInlineList"
      *ngIf="
        isNovaPoshtaWarehouseListOpen && selectedNovaPoshtaCity && novaPoshtaWarehouseResults.length
      "
    >
      <button
        #novaPoshtaWarehouseOption
        type="button"
        class="novaPoshtaInlineOption"
        [class.isActive]="index === novaPoshtaWarehouseActiveIndex"
        *ngFor="let warehouse of novaPoshtaWarehouseResults; let index = index"
        (mouseenter)="novaPoshtaWarehouseActiveIndex = index"
        (mousedown)="$event.preventDefault()"
        (click)="selectNovaPoshtaWarehouse(warehouse)"
      >
        <span>{{ getNovaPoshtaWarehouseKindLabel(warehouse) }}</span>
        <small>{{ warehouse.shortAddress || warehouse.description }}</small>
      </button>
    </div>

    <div class="novaPoshtaRecipientFields">
      <div class="novaPoshtaRecipientTitle">Получатель</div>
      <mat-form-field appearance="outline">
        <mat-label>Имя</mat-label>
        <input
          matInput
          autocomplete="given-name"
          [formControl]="novaPoshtaRecipientFirstNameControl"
        />
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Фамилия</mat-label>
        <input
          matInput
          autocomplete="family-name"
          [formControl]="novaPoshtaRecipientLastNameControl"
        />
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Телефон</mat-label>
        <input
          matInput
          type="tel"
          autocomplete="tel"
          [formControl]="novaPoshtaRecipientPhoneControl"
        />
      </mat-form-field>
    </div>
  </div>
</ng-template>

<div
  class="productImageHoverPreview"
  *ngIf="hoveredProductImageUrl"
  [style.left.px]="hoveredProductImagePreviewLeft"
  [style.top.px]="hoveredProductImagePreviewTop"
>
  <img
    [src]="hoveredProductImageUrl"
    [alt]="hoveredProductImageTitle || 'Изображение товара'"
    (error)="onProductImageError(hoveredProductImageUrl)"
  />
</div>
